module.exports = __webpack_public_path__ + "img/inktober_2020_17_rough.b1756bda.jpg";